<template>
    <div>
        <i class="fa-duotone fa-fw" :class="displayClass"></i>
    </div>
</template>

<script>
    export default {
        name: 'VideoStreamerStatus',
        data() {
            return {
                timer: null,
                connectionStatus: '',
                displayClass: 'text-muted'
            };
        },
        created() {
            let self = this;

            this.timer = setInterval(self.checkConnectionStatus, 1000);
        },
        destroyed() {
            clearInterval(this.timer);
        },
        methods: {
            checkConnectionStatus() {
                if (this.$qz.failed) {
                    this.connectionStatus = 'Error';
                    this.displayClass = 'fa-webcam-slash text-danger';
                }

                if (this.$qz.connecting) {
                    this.connectionStatus = 'Connecting';
                    this.displayClass = 'fa-webcam text-warning';
                }

                if (this.$qz.disconnecting) {
                    this.connectionStatus = 'Disconnecting';
                    this.displayClass = 'fa-webcam text-warning';
                }

                if (this.$qz.connected) {
                    this.connectionStatus = 'Connected';
                    this.displayClass = 'fa-webcam text-success';
                }

                if (! this.$qz.connected) {
                    this.connectionStatus = 'Disconnected';
                    this.displayClass = 'fa-webcam-slash text-muted';
                }
            },
        }

    };
</script>

<style scoped>

</style>